/** VUEX module for advertisement management **/
import responseNotification from '../lib/responseNotification.js'

import {
  copyAd,
  createAd,
  deleteAd,
  getAds,
  regenerateAdvertisementsCode,
  shareAd,
  updateAd,
  loadSingleAd
} from '../lib/api/calls'

export default {
  namespaced: true,
  state: {
    ads: [],
    single_ad: {}
  },
  getters: {
    getSortedAds (state) {
      return state.ads.sort(function (a, b) {
        return ('' + b.updated_at).localeCompare(a.updated_at)
      })
    }
  },
  mutations: {
    setAds (state, value) {
      if (!Array.isArray(value)) value = []

      value = value.map((item) => {
        if (typeof item.json == 'string') {
          item.json = JSON.parse(item.json)
          item.link = '/' + ['configuration', item.format_id, item.id].join('/')
        }

        return item
      })

      state.ads = value
    },
    setSingleAd (state, value) {
      state.single_ad = value;
    }
  },
  actions: {
    async load ({commit}, payload) {
      await getAds().then(ads => commit('setAds', ads))
    },
    async loadSingle ({commit}, id) {
      await loadSingleAd(id).then((response) => commit('setSingleAd', response))
    },
    regenerate (context, formatId) {
      regenerateAdvertisementsCode(formatId).then((response) => {
        responseNotification(context, response, 'Ad Format Reloaded!')
      })
    },
    create (context, {data, callback}) {
      createAd(data).then((response) => {
        responseNotification(context, response, 'Ad created!')
        context.dispatch('load')
        if (callback) callback(response)
      }).catch((e) => {
        console.error(e);
        console.error(data);
        if (FS) {
          FS.log('error', data);
          FS.log('error', e.toString());
        }
        responseNotification(context, {error: 'This ad could not be saved'})
      })
    },
    update (context, {id, ad, callback}) {
      updateAd(id, ad).then((response) => {
        responseNotification(context, response, 'Ad updated!')
        context.dispatch('load')
        if (callback) callback(response)
      })
    },
    copy (context, id) {
      responseNotification(context, {info: 'Duplicating ad...'}, null, {showProgressBar: false})
      copyAd(id).then((response) => {
        responseNotification(context, response, 'Ad copied!')
        context.dispatch('load')
      })
    },
    delete (context, id) {
      deleteAd(id).then((response) => {
        responseNotification(context, response, 'Ad deleted!')
        context.dispatch('load')
      })
    },
    share (context, {email, url}) {
      shareAd(email, url).then((response) => {
        responseNotification(context, response, 'Ad Shared')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/advertisements.js